import {
  BodyText,
  Card,
  CardContent,
  Checkbox,
  Flex,
  Heading,
  ValidationText,
} from '@utilitywarehouse/hearth-react';
import { useFormikContext } from 'formik';

import { IPLegalSectionValues } from '../validationSchema';
import { declarationFields } from './declarationFields';
import './styles.scss';

const Declarations: React.FC = () => {
  const {
    values,
    handleChange,
    handleBlur,
    setFieldValue,
    errors,
    submitCount,
  } = useFormikContext<IPLegalSectionValues>();

  const declarationsError = errors.declarations as string | undefined;

  return (
    <Card
      variant="emphasis"
      colorScheme="neutralStrong"
      className="incomeProtectorDeclarations__wrapper"
    >
      <CardContent direction="column" spacing="lg">
        <Heading as="h3" size="lg">
          Declarations
        </Heading>
        <Flex direction="column" spacing="lg">
          <BodyText>
            We want to make sure this product is right for you. Please check the
            following eligibility criteria apply to everyone you intend to be
            named on your UW account:
          </BodyText>

          {declarationFields.map(({ key, testId, label }) => (
            <Checkbox
              key={key}
              data-testid={testId}
              id={testId}
              name={`declarations.${key}`}
              checked={
                values.declarations[key as keyof typeof values.declarations]
              }
              onChange={handleChange}
              onBlur={handleBlur}
              onCheckedChange={(checked) =>
                setFieldValue(`declarations.${key}`, checked)
              }
              label={label}
            />
          ))}

          {submitCount > 0 && declarationsError && (
            <ValidationText
              data-testid="declarations-error"
              status="invalid"
              id="declarations"
            >
              {declarationsError}
            </ValidationText>
          )}
        </Flex>
      </CardContent>
    </Card>
  );
};

export { Declarations };
